import { Box } from "@mui/material";
import { H1 } from "../components/Typography";

const GoalTopBanner = () => {
  return (
    <Box
      sx={{
        borderRadius: 5,
        display: {
          md: "flex",
          xs: "none",
        },
        justifyContent: "space-between",
        alignItems: "center",
        background: "linear-gradient(91.86deg, #0073FF 0.26%, #044EA7 101.51%)",
        flexDirection: {
          xs: "column",
          sm: "column",
          md: "row",
        },
      }}
    >
      <Box
        component="img"
        sx={{
          height: {
            xs: "60%",
            sm: "60%",
            md: "20%",
          },
          width: {
            xs: "60%",
            sm: "60%",
            md: "15%",
          },
          ml: 2,
        }}
        src="https://acru-asset.s3.us-east-1.amazonaws.com/assets/goalLeftBanner.svg"
        alt="saas-dasboard-footer"
      />

      <Box
        justifyContent="center"
        textAlign="center"
        sx={{
          width: {
            xs: "80%",
            sm: "80%",
            md: "60%",
          },
          paddingY: {
            xs: 2,
            sm: 2,
            md: 5,
          },
        }}
      >
        <H1
          fontSize={24}
          fontWeight={600}
          sx={{
            textAlign: "center",
            fontFamily: "'Poppins', sans-serif",
          }}
          color="#ffffff"
        >
          Invest for your future with mutual funds – the smart way to grow your
          wealth
        </H1>
      </Box>
      <Box
        component="img"
        sx={{
          height: {
            xs: "60%",
            sm: "60%",
            md: "25%",
          },
          width: {
            xs: "60%",
            sm: "60%",
            md: "12%",
          },
          mr: 2,
          display: {
            xs: "none",
            md: "block",
          },
        }}
        src="https://acru-asset.s3.us-east-1.amazonaws.com/assets/goalRightBanner.svg"
        alt="saas-dasboard-footer"
      />
    </Box>
  );
};

export default GoalTopBanner;
